import axios from "../../axios/axios";

import * as apis from "../../apis";
import * as errors from "../../errors"
import * as successes from "../../successes"

import {CLOSE_TABLE_MODAL, CLOSE_TABLELINK_MODAL} from "./ui";
import {getReservations} from "./reservations";

import {getAxiosTokenConfig} from "../../helpers";

import {notifyError, notifySuccess} from "../../toast-notifications";
import { zoneRefresh } from "./autoRefresh";
import { getZoneItems } from "./zones";


// GET TABLES
export const GET_TABLES_REQUEST = "GET_TABLES_REQUEST";
export const GET_TABLES_SUCCESS = "GET_TABLES_SUCCESS";
export const GET_TABLES_ERROR = "GET_TABLES_ERROR";

export const getTablesRequest = () => {
    return {
        type: GET_TABLES_REQUEST,
        loading: true
    };
};
export const getTablesSuccess = (tables) => {
    return {
        type: GET_TABLES_SUCCESS,
        loading: false,
        error: null,
        tables
    };
};
export const getTablesError = (error) => {
    return {
        type: GET_TABLES_ERROR,
        loading: false,
        error
    };
};
export const getTables = () => {
    return dispatch => {
        dispatch(getTablesRequest());
        axios.get(apis.GET_TABLES_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getTablesSuccess(response.data));
            })
            .catch(error => {
                dispatch(getTablesError(errors.GET_TABLES_ERROR));
                notifyError(errors.GET_TABLES_ERROR);
            });
    };
};

// ADD TABLE
export const ADD_TABLE_REQUEST = "ADD_TABLE_REQUEST";
export const ADD_TABLE_SUCCESS = "ADD_TABLE_SUCCESS";
export const ADD_TABLE_ERROR = "ADD_TABLE_ERROR";

export const addTableRequest = () => {
    return {
        type: ADD_TABLE_REQUEST,
        loading: true
    };
};
export const addTableSuccess = (table) => {
    return {
        type: ADD_TABLE_SUCCESS,
        loading: false,
        error: null,
        table
    };
};
export const addTableError = (error) => {
    return {
        type: ADD_TABLE_ERROR,
        loading: false,
        error
    };
};
export const addTable = (table) => {
    return dispatch => {
        dispatch(addTableRequest());
        axios.post(apis.ADD_TABLE_API, table, getAxiosTokenConfig())
            .then(response => {
                dispatch(addTableSuccess(response.data));
                notifySuccess(successes.ADD_TABLE_SUCCESS);
                dispatch(getZoneItems());
            })
            .catch(error => {
                dispatch(addTableError(errors.ADD_TABLE_ERROR));
                notifyError(errors.ADD_TABLE_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_TABLE_MODAL});
            });
    };
};

// DELETE TABLE
export const DELETE_TABLE_REQUEST = "DELETE_TABLE_REQUEST";
export const DELETE_TABLE_SUCCESS = "DELETE_TABLE_SUCCESS";
export const DELETE_TABLE_ERROR = "DELETE_TABLE_ERROR";

export const deleteTableRequest = () => {
    return {
        type: DELETE_TABLE_REQUEST,
        loading: true
    };
};
export const deleteTableSuccess = (tableId) => {
    return {
        type: DELETE_TABLE_SUCCESS,
        loading: false,
        error: null,
        tableId
    };
};
export const deleteTableError = (error) => {
    return {
        type: DELETE_TABLE_ERROR,
        loading: false,
        error
    };
};
export const deleteTable = (id) => {
    return dispatch => {
        dispatch(deleteTableRequest());
        axios.delete(apis.DELETE_TABLE_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteTableSuccess(id));
                dispatch(getReservations());
                dispatch(getTableLinks());
                dispatch(getZoneItems());
                notifySuccess(successes.DELETE_TABLE_SUCCESS);
            })
            .catch(error => {
                dispatch(deleteTableError(error));
                notifyError(errors.DELETE_TABLE_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_TABLE_MODAL});
            });
    };
};

// UPDATE TABLE
export const UPDATE_TABLE_REQUEST = "UPDATE_TABLE_REQUEST";
export const UPDATE_TABLE_SUCCESS = "UPDATE_TABLE_SUCCESS";
export const UPDATE_TABLE_ERROR = "UPDATE_TABLE_ERROR";

export const updateTableRequest = () => {
    return {
        type: UPDATE_TABLE_REQUEST,
        loading: true
    };
};
export const updateTableSuccess = (table) => {
    return {
        type: UPDATE_TABLE_SUCCESS,
        loading: false,
        error: null,
        table
    };
};
export const updateTableError = (error) => {
    return {
        type: UPDATE_TABLE_ERROR,
        loading: false,
        error
    };
};
export const updateTable = (table) => {
    return dispatch => {
        dispatch(updateTableRequest());
        axios.patch(apis.UPDATE_TABLE_API + table.id + "/", table, getAxiosTokenConfig())
            .then(response => {
                dispatch(getReservations());
                dispatch(getZoneItems());
                dispatch(updateTableSuccess(response.data));
                notifySuccess(successes.UPDATE_TABLE_SUCCESS);
            })
            .catch(error => {
                dispatch(updateTableError(error));
                notifyError(errors.UPDATE_TABLE_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_TABLE_MODAL});
                dispatch(zoneRefresh());
            });
    };
};


// GET TABLELINKS
export const GET_TABLELINKS_REQUEST = "GET_TABLELINKS_REQUEST";
export const GET_TABLELINKS_SUCCESS = "GET_TABLELINKS_SUCCESS";
export const GET_TABLELINKS_ERROR = "GET_TABLELINKS_ERROR";

export const getTableLinksRequest = () => {
    return {
        type: GET_TABLELINKS_REQUEST,
        loading: true
    };
};
export const getTableLinksSuccess = (tableLinks) => {
    return {
        type: GET_TABLELINKS_SUCCESS,
        loading: false,
        error: null,
        tableLinks
    };
};
export const getTableLinksError = (error) => {
    return {
        type: GET_TABLELINKS_ERROR,
        loading: false,
        error
    };
};
export const getTableLinks = () => {
    return dispatch => {
        dispatch(getTableLinksRequest());
        axios.get(apis.GET_TABLELINKS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getTableLinksSuccess(response.data));
            })
            .catch(error => {
                dispatch(getTableLinksError(errors.GET_TABLELINKS_ERROR));
                notifyError(errors.GET_TABLELINKS_ERROR);
            });
    };
};

// ADD TABLELINK
export const ADD_TABLELINK_REQUEST = "ADD_TABLELINK_REQUEST";
export const ADD_TABLELINK_SUCCESS = "ADD_TABLELINK_SUCCESS";
export const ADD_TABLELINK_ERROR = "ADD_TABLELINK_ERROR";

export const addTableLinkRequest = () => {
    return {
        type: ADD_TABLELINK_REQUEST,
        loading: true
    };
};
export const addTableLinkSuccess = (tableLink) => {
    return {
        type: ADD_TABLELINK_SUCCESS,
        loading: false,
        error: null,
        tableLink
    };
};
export const addTableLinkError = (error) => {
    return {
        type: ADD_TABLELINK_ERROR,
        loading: false,
        error
    };
};
export const addTableLink = (tableLink) => {
    return dispatch => {
        dispatch(addTableLinkRequest());
        axios.post(apis.ADD_TABLELINK_API, tableLink, getAxiosTokenConfig())
            .then(response => {
                dispatch(addTableLinkSuccess(response.data));
                notifySuccess(successes.ADD_TABLELINK_SUCCESS);
            })
            .catch(error => {
                dispatch(addTableLinkError(errors.ADD_TABLELINK_ERROR));
                notifyError(errors.ADD_TABLELINK_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_TABLELINK_MODAL});
            });
    };
};

// DELETE TABLELINK
export const DELETE_TABLELINK_REQUEST = "DELETE_TABLELINK_REQUEST";
export const DELETE_TABLELINK_SUCCESS = "DELETE_TABLELINK_SUCCESS";
export const DELETE_TABLELINK_ERROR = "DELETE_TABLELINK_ERROR";

export const deleteTableLinkRequest = () => {
    return {
        type: DELETE_TABLELINK_REQUEST,
        loading: true
    };
};
export const deleteTableLinkSuccess = (tableLinkId) => {
    return {
        type: DELETE_TABLELINK_SUCCESS,
        loading: false,
        error: null,
        tableLinkId
    };
};
export const deleteTableLinkError = (error) => {
    return {
        type: DELETE_TABLELINK_ERROR,
        loading: false,
        error
    };
};
export const deleteTableLink = (id) => {
    return dispatch => {
        dispatch(deleteTableLinkRequest());
        axios.delete(apis.DELETE_TABLELINK_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteTableLinkSuccess(id));
                notifySuccess(successes.DELETE_TABLELINK_SUCCESS);
            })
            .catch(error => {
                dispatch(deleteTableLinkError(error));
                notifyError(errors.DELETE_TABLELINK_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_TABLELINK_MODAL});
            });
    };
};

// UPDATE TABLELINK
export const UPDATE_TABLELINK_REQUEST = "UPDATE_TABLELINK_REQUEST";
export const UPDATE_TABLELINK_SUCCESS = "UPDATE_TABLELINK_SUCCESS";
export const UPDATE_TABLELINK_ERROR = "UPDATE_TABLELINK_ERROR";

export const updateTableLinkRequest = () => {
    return {
        type: UPDATE_TABLELINK_REQUEST,
        loading: true
    };
};
export const updateTableLinkSuccess = (tableLink) => {
    return {
        type: UPDATE_TABLELINK_SUCCESS,
        loading: false,
        error: null,
        tableLink
    };
};
export const updateTableLinkError = (error) => {
    return {
        type: UPDATE_TABLELINK_ERROR,
        loading: false,
        error
    };
};
export const updateTableLink = (tableLink) => {
    return dispatch => {
        dispatch(updateTableLinkRequest());
        axios.patch(apis.UPDATE_TABLELINK_API + tableLink.id + "/", tableLink, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateTableLinkSuccess(response.data));
                notifySuccess(successes.UPDATE_TABLELINK_SUCCESS);
            })
            .catch(error => {
                dispatch(updateTableLinkError(error));
                notifyError(errors.UPDATE_TABLELINK_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_TABLELINK_MODAL});
            });
    };
};

// GET TABLE TYPES
export const GET_TABLE_TYPES_REQUEST = "GET_TABLE_TYPES_REQUEST";
export const GET_TABLE_TYPES_SUCCESS = "GET_TABLE_TYPES_SUCCESS";
export const GET_TABLE_TYPES_ERROR = "GET_TABLE_TYPES_ERROR";

export const getTableTypesRequest = () => {
    return {
        type: GET_TABLE_TYPES_REQUEST,
        loading: true
    };
};
export const getTableTypesSuccess = (tableTypes) => {
    return {
        type: GET_TABLE_TYPES_SUCCESS,
        loading: false,
        error: null,
        tableTypes
    };
};
export const getTableTypesError = (error) => {
    return {
        type: GET_TABLE_TYPES_ERROR,
        loading: false,
        error
    };
};
export const getTableTypes = () => {
    return dispatch => {
        dispatch(getTableTypesRequest());
        axios.get(apis.GET_TABLE_TYPES_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getTableTypesSuccess(response.data));
            })
            .catch(error => {
                dispatch(getTableTypesError(errors.GET_TABLE_TYPES_ERROR));
                notifyError(errors.GET_TABLE_TYPES_ERROR);
            });
    };
};

export const SET_TABLES = "SET_TABLES";

export const SET_TABLELINKS = "SET_TABLELINKS";


// WEBPACK FOOTER //
// ./src/store/actions/tables.js